import messages from './messages.json';
import {
  footerTextClassName,
  footerTextLabelClassName,
  footerTextValueClassName,
} from './styles';

interface Props {
  numPosts: number;
}

const CardHeroPostCount = ({ numPosts }: Props) => {
  return (
    <h6 className={footerTextClassName}>
      <span className={footerTextValueClassName}>{numPosts}</span>
      <span className={footerTextLabelClassName}>
        {numPosts === 1
          ? messages.postCountSingularLabel
          : messages.postCountLabel}
      </span>
    </h6>
  );
};

CardHeroPostCount.displayName = 'CardHeroPostCount';

export default CardHeroPostCount;
